import { Api } from './axios-config';
import { IPagedResult } from './pagedResult';

export interface ITransactionView {
  id: number;
  businessId: number;
  caixaId?: number;
  caixaInfo?: string;
  caixaIsOpen?: boolean;
  type: number;
  typeName: string;
  amount: number;
  description: string;
  category?: string;
  createdAt: Date;
  createdByName: string;
}

export interface ICreateTransactionDto {
  businessId: number;
  caixaId?: number;
  type: number;
  amount: number;
  description: string;
  category?: string;
}

const create = async (body: ICreateTransactionDto): Promise<number> => {
  try {
    const { data } = await Api.post<number>('/transactions', body);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getByBusiness = async (businessId: number, page: number, pageSize: number, startDate?: Date, endDate?: Date): Promise<IPagedResult<ITransactionView>> => {
  try {
    const params = new URLSearchParams();
    params.append('businessId', businessId.toString());
    params.append('page', page.toString());
    params.append('pageSize', pageSize.toString());
    if (startDate) params.append('startDate', startDate.toISOString());
    if (endDate) params.append('endDate', endDate.toISOString());

    const { data } = await Api.get<IPagedResult<ITransactionView>>(`/transactions?${params.toString()}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const remove = async (id: number, businessId: number): Promise<void> => {
  try {
    await Api.delete(`/transactions/${id}?businessId=${businessId}`);
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const transactionService = {
  create,
  getByBusiness,
  remove,
};
